export default "__VITE_ASSET__en5bB840__"